import { ClickstreamConstants } from "@packages/shared-components/services/constants";
const buildDigitalOrEmailProspectusUrl = (enquiryProps: any) => {
  const baseUrl = `/degrees/prospectus${enquiryProps?.collegeName ? `/${enquiryProps?.collegeName}-prospectus` : ""}${enquiryProps?.collegeId ? `/${enquiryProps?.collegeId}` : ""}${enquiryProps?.courseId ? `/${enquiryProps?.courseId}` : "/0"}${enquiryProps?.selectedSubject ? `/${enquiryProps?.selectedSubject}` : "/0"}`;

  const sponsorParam = getSponsorOrderItemId(enquiryProps);
  const subOrderId = enquiryProps?.subOrderItemId;
  const pageName = enquiryProps?.pageName;

  if (pageName === "browsemoneypageresults") {
    return subOrderId
      ? `${baseUrl}/n-${subOrderId}/order-prospectus.html?${sponsorParam}&manualBoostingFlag=${enquiryProps?.manualBoostingFlag || "N"}&pageName=sr`
      : `${baseUrl}/n-/order-prospectus.html?${sponsorParam}&pageName=sr&nonAdvertiserFlag=Y`;
  }

  if (
    ["coursesearchresult", "coursedetails", "contenthub"].includes(pageName)
  ) {
    return subOrderId
      ? `${baseUrl}/n-${subOrderId}/order-prospectus.html?${sponsorParam}&pageName=${pageName}`
      : `${baseUrl}/n-/order-prospectus.html?${sponsorParam}&pageName=${pageName}&nonAdvertiserFlag=Y`;
  }

  return baseUrl;
};

const getSponsorOrderItemId = (enquiryProps: any) => {
  return `sponsoredOrderItemId=${enquiryProps?.sponsoredListingFlag === "Y" ? enquiryProps?.orderItemId || "" : ""}`;
};

const getFunctionalityName = (enquiryProps: any, clearing: boolean) => {
  if (enquiryProps?.functionalityName) return enquiryProps.functionalityName;
  if (clearing) return "Clearing";
  if (enquiryProps?.sponsoredListingFlag === "Y")
    return ClickstreamConstants.sponsorListing;
  return "VisitWebsite";
};

const buildBookingUrl = (response: any, enquiryProps: any) => {
  const params = [];
  params.push(`collegeId=${enquiryProps?.collegeId || "0"}`);
  if (enquiryProps?.courseId) {
    params.push(`courseId=${enquiryProps.courseId}`);
  }
  if (enquiryProps?.subOrderItemId) {
    params.push(`suborderItemId=${enquiryProps.subOrderItemId}`);
  }
  if (response?.eventId) {
    params.push(`eventId=${response.eventId}`);
  }
  const sponsoredOrderItemId =
    enquiryProps?.sponsoredListingFlag === "Y"
      ? enquiryProps?.orderItemId
      : "0";
  params.push(`sponsoredOrderItemId=${sponsoredOrderItemId}`);
  params.push(`manualBoostingFlag=${enquiryProps?.manualBoostingFlag || "N"}`);
  params.push(`pageName=${enquiryProps?.pageName || ""}`);
  return `/open-days/book?${params.join("&")}`;
};

export {
  buildDigitalOrEmailProspectusUrl,
  getSponsorOrderItemId,
  getFunctionalityName,
  buildBookingUrl,
};
